module.exports = __webpack_public_path__ + "img/ERP_swiperTab_bg2.16a7cc0f.png";